import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from './AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, loading } = useAuthContext();
  
  // Hiển thị loading nếu đang kiểm tra authentication
  if (loading) {
    return <LoadingSpinner message="Đang kiểm tra quyền truy cập..." />;
  }
  
  // Nếu chưa đăng nhập, chuyển hướng về trang login
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  
  // Nếu đã đăng nhập, render component con
  return children;
};

export default ProtectedRoute; 